import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { Radio } from '../../Reviews/Forms';
import { Inner } from './partials';
export var RadioGroup = function RadioGroup(_ref) {
  var name = _ref.name,
    options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'block' : _ref$display;
  return React.createElement(Inner, {
    display: display
  }, options.map(function (option) {
    var id = "".concat(name, "-option-").concat(option.id);
    return React.createElement(Radio, {
      key: id,
      name: id,
      id: id,
      checked: value.id === option.id,
      handleChange: function handleChange() {
        onChange(option);
      },
      value: "checked"
    }, option.label);
  }));
};